import styled from '@emotion/styled'
import { colors } from '../../../shared/ui/colors'

export const MatrixHeaderContainer = styled.h4`
  margin: 0;
  font-size: 14px;
  color: ${colors.gray900};
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${colors.white};
`
